var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconUpdates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A0EE09",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 21.563V15.5C32.25 14.9477 31.8023 14.5 31.25 14.5H30.25C28.2714 16.4786 24.5527 17.5873 22.25 18.1128V28.8872C24.5527 29.4127 28.2714 30.5214 30.25 32.5H31.25C31.8023 32.5 32.25 32.0523 32.25 31.5V25.437C33.1126 25.215 33.75 24.4319 33.75 23.5C33.75 22.5681 33.1126 21.785 32.25 21.563ZM16.25 18.5C15.1454 18.5 14.25 19.3954 14.25 20.5V26.5C14.25 27.6046 15.1454 28.5 16.25 28.5H17.25L18.25 33.5H20.25V18.5H16.25Z",
    fill: "#A0EE09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconUpdates);
export default __webpack_public_path__ + "static/media/menu-icon-updates.7fa274db1d8806297e0a4649c025dd65.svg";
export { ForwardRef as ReactComponent };